import React, { useContext } from "react"
import { ModalContext } from "../../../../components/contexts/ModalContext"
import { P } from "../../../../auth/permissions"
import { Authorized } from "../../../../components/authentication/Authorized"

type BillDetailButtonRowType = {
    canceled: boolean
    handleDownload: (e?: { s3Key: string; filename: string }) => void
    handleChangePreviewElement: () => void
    stornoS3Ref?: {
        s3Key: string
        filename: string
    }
    updatedNoteEqualNoteData?: boolean
    handleSaveNote: () => void
}

export default function BillDetailButtonRow(props: BillDetailButtonRowType) {
    const modalCon = useContext(ModalContext)

    return (
        <Authorized allOf={[P.buchhaltung_read_write]}>
            <div className="flex flex-row justify-end p-4 rounded-default shadow-lg bg-white mt-4 gap-2">
                <button onClick={props.handleChangePreviewElement} className="hidden sm:block btn btn-primary btn-outline">
                    Vorschau
                </button>
                <button onClick={() => props.handleDownload()} className="hidden sm:block btn btn-primary btn-outline">
                    Download
                </button>
                <button onClick={() => modalCon?.trigger(0)} className="btn btn-primary btn-outline">
                    Archivieren
                </button>
                {!props.canceled && (
                    <button onClick={() => modalCon?.trigger(2)} className="hidden sm:block btn btn-primary btn-outline">
                        Stornieren
                    </button>
                )}
                {props.stornoS3Ref && (
                    <button onClick={() => props.handleDownload(props.stornoS3Ref)} className="hidden sm:block btn btn-primary btn-outline">
                        Download Stornierung
                    </button>
                )}
                {!props.updatedNoteEqualNoteData && (
                    <button className="btn btn-primary" onClick={() => props.handleSaveNote()}>
                        Speichern
                    </button>
                )}
            </div>
        </Authorized>
    )
}
